// extracted by mini-css-extract-plugin
var _1 = "styles_item__PsmEn";
var _2 = "styles_mobileItems__HRgfk";
var _3 = "styles_surprise__ZDPlP";
export { _1 as "item", _2 as "mobileItems", _3 as "surprise" }
